import { useQuery } from 'react-query'
import { api } from '../api'
import { toast } from 'react-toastify'
import { useAuth } from '../../context/AuthContext'
import { useHistory } from 'react-router-dom'


export async function getAllProducts(idBusiness) {
    const token = localStorage.getItem('@Inoveclube:token')

    const response = await api.get(`/getProductsWithGroups/${idBusiness}/${token}/${true}`)

    return response.data
}


export function useProduct(businessName) {
    const { signOut } = useAuth()
    const history = useHistory()

    return useQuery(
        'products', 
        () => getAllProducts(businessName),
        {
            staleTime: 1000 * 60, // 60 seconds
            refetchOnWindowFocus: false,
            onError: () => {
                signOut()
                history.push('/login')
                toast.warning('Sua sessão expirou, faça login novamente')
            }
        },
    )
}